import { CurrentUserDTO } from '@app/auth/dto';
import { checkAuth } from '@app/auth/helpers';
import { UserRoleEnum } from '@app/users/dto';
import { RESOURCES } from '@constants';
import { AccessControlProvider } from '@refinedev/core';

export const accessControlProvider = (session: CurrentUserDTO | undefined): AccessControlProvider =>
  ({
    can: async ({ resource }) => {
      if (resource === RESOURCES.dashboard) {
        return {
          can: true,
        };
      }

      if (resource === RESOURCES.users) {
        return {
          can: checkAuth({ roles: [UserRoleEnum.SimAdmin, UserRoleEnum.SimManager] }, session),
        };
      }
      if (resource === RESOURCES.profiles) {
        return {
          can: checkAuth({ roles: [UserRoleEnum.SimManager, UserRoleEnum.SimOperator] }, session),
        };
      }
      if (resource === RESOURCES.devices) {
        return {
          can: checkAuth({ roles: [UserRoleEnum.SimManager, UserRoleEnum.SimOperator] }, session),
        };
      }
      if (resource === RESOURCES.carriers) {
        return {
          can: checkAuth({ roles: [UserRoleEnum.SimManager, UserRoleEnum.SimOperator] }, session),
        };
      }

      if (resource === RESOURCES.customers) {
        return {
          can: checkAuth({ roles: [UserRoleEnum.SimAdmin] }, session),
        };
      }
      if (resource === RESOURCES.logs) {
        return {
          can: true,
        };
      }
      if (resource === RESOURCES.applicationVersions) {
        return {
          can: true,
        };
      }
      if (resource === RESOURCES.settings) {
        return {
          can: true,
        };
      }

      return { can: false };
    },
    options: {
      buttons: {
        enableAccessControl: true,
        hideIfUnauthorized: false,
      },
      queryOptions: {},
    },
  }) as AccessControlProvider;
